export const ACCESS_LEVELS = {
    READ_ONLY: "tracksim_readonly",
    USER: "tracksim_user",
    ADMIN: "tracksim_admin"
}